var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAssessments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_assessments_svg__UI",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon_assessments_svg__icon_assessments",
    "data-name": "icon_assessments",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_assessments_svg__cls-1",
    d: "M17.6 14.4H32V32H17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon_assessments_svg__cls-1",
    d: "M17.6 28.8h-3.2a1.6 1.6 0 01-1.6-1.6V12.8a1.6 1.6 0 011.6-1.6h11.2a1.6 1.6 0 011.6 1.6v1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon_assessments_svg__cls-1",
    d: "M12.8 25.6H9.6A1.6 1.6 0 018 24V9.6A1.6 1.6 0 019.6 8h11.2a1.6 1.6 0 011.6 1.6v1.6M25.6 19.2h3.2M20.8 18.4l.8.8 1.6-1.6M25.6 24h3.2M20.8 23.2l.8.8 1.6-1.6M25.6 28.8h3.2M20.8 28l.8.8 1.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".icon_assessments_svg__cls-1{fill:none;stroke:#575757;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 40,
    height: 40,
    xlinkHref: "#icon_assessments_svg__icon_assessments"
  })));
}
export default SvgIconAssessments;